// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "script/chunks/chunk." + (chunkId === 36 ? "braintree-web-drop-in" : chunkId) + "." + {"15":"09cddc39e1","36":"80c03f3d13","70":"b474bffceb","71":"5d4c37ded8"}[chunkId] + ".js";
};